import React from 'react';
import Hero from './Hero/Hero';
import MainNav from './Navbar/MainNav';

const Header = () => {
  return (
    <header>
      <MainNav />
    </header>
  );
};

export default Header;
